import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  Input,
  InputGroup,
  InputRightElement,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import calendarIcon from "../../../assets/images/onleave/calendar.svg";
import imageIcon from "../../../assets/images/booking/image.svg";
import {
  InputControl,
  SelectControl,
  TextareaControl,
} from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useCategories } from "../../../categorys/makeupWorkRequest/add";
import { commonCall } from "../../../api/common";
import toast from "react-hot-toast";
import { formatPriceUS } from "../../../utils/utils";
import { useCallback } from "react";
import DatePicker from "react-datepicker";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const schema = Yup.object().shape({});

const FormDetail = memo(
  ({ isOpen, onClose, onSubmit, isEdit, defaultValues }) => {
    const {
      reset,
      setValue,
      register,
      handleSubmit,
      watch,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      defaultValues: defaultValues || {},
    });

    const [zIndex, setZIndex] = useState("");

    const [focusStates, setFocusStates] = useState({});

    const [isLoadingUpload, setIsloadingUpload] = useState(false);

    const [images, setImages] = useState([]);
    const [imagesError, setImagesError] = useState(false);

    const [shouldFetch, setShouldFetch] = useState(false);
    const imageRefs = useRef([]);

    // Chọn ảnh là tự upload (selectedFile), nút "Tải lại" chỉ dùng khi upload lỗi
    const handleUploadImages = async (index, selectedFile) => {
      const file = selectedFile || images[index]?.file;
      if (!file) return;

      // Tìm ảnh theo file vì trong lúc upload có thể đã xoá ô khác hoặc chọn ảnh khác
      const updateImage = (data) =>
        setImages((prev) => {
          const position = prev.findIndex((item) => item?.file === file);
          if (position < 0) return prev;
          const updated = [...prev];
          updated[position] = { ...updated[position], ...data };
          return updated;
        });

      updateImage({ uploading: true });

      try {
        const { filePath } = await commonCall.uploadFile(
          file,
          "salesContractImage"
        );

        if (filePath) {
          updateImage({ path: filePath, status: true, uploading: false });
          toast.success("Upload ảnh thành công");
        } else {
          updateImage({ uploading: false });
          toast.error("Upload thất bại");
        }
      } catch (error) {
        // commonCall.uploadFile đã báo lỗi bằng toast
        updateImage({ uploading: false });
      }
    };

    useEffect(() => {
      reset(defaultValues);

      if (defaultValues?.id) {
        const fetchData = async () => {
          try {
            setImages([]);

            if (defaultValues?.images?.length) {
              const initImages = defaultValues.images?.map((path, idx) => ({
                id: Date.now() + idx,
                path,
                imageUrl: null,
                file: null,
                status: true, // ảnh đã upload
              }));
              setImages(initImages);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
        fetchData();
      }
    }, [isOpen]);

    useEffect(() => {
      const timer = setTimeout(() => {
        setShouldFetch(true);
      }, 1200);

      return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
      setValue("images", images);
      if (images?.length > 0 && images?.filter((img) => img.status === false)) {
        setImagesError(true);
      } else {
        setImagesError(false);
      }
    }, [images, setValue]);

    const { constantData } = useCategories(shouldFetch);

    const formatEntries = (entries) =>
      Object.entries(entries || {}).map(([key, value]) => ({
        value: key,
        label: value,
      }));

    const employees = useMemo(
      () => formatEntries(constantData?.employee || {}),
      [constantData?.employee]
    );

    const onchangeEmpoyeeList = (option) => {
      setValue("employeeId", option);
    };

    const handleFocus = (field) => {
      setFocusStates((prev) => ({ ...prev, [field]: true }));
    };

    const handleBlur = (field) => {
      setFocusStates((prev) => ({ ...prev, [field]: false }));
    };

    const handleDatePickerChange = (e, inputName) => {
      setValue(inputName, e, { shouldValidate: true });
    };

    //Images anh UNC

    const handleAddImages = () => {
      setImages((prev) => {
        const newImage = {
          id: Date.now(),
          path: null,
          imageUrl: null,
          file: null,
          status: false,
        };

        setTimeout(() => {
          const index = prev?.length; // index mới
          imageRefs.current[index]?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100); // để DOM cập nhật xong mới scroll

        return [...prev, newImage];
      });
    };

    const handleChangeImages = (e, index) => {
      const file = e.target.files[0];
      if (!file) return;

      const imageUrl = URL.createObjectURL(file);
      const updated = [...images];
      updated[index] = {
        ...updated[index],
        file,
        imageUrl,
        status: false,
        path: null,
      };
      setImages(updated);
      handleUploadImages(index, file);
    };

    const handleRemoveImages = (index) => {
      const updated = [...images];
      updated.splice(index, 1);
      setImages(updated);
      if (images?.length === 0) {
        setImagesError(false);
      }
    };

    const submitHandler = (data) => {
      if (images?.length > 0) {
        data.images = images.filter((img) => img?.path).map((img) => img.path);
      } else {
        data.images = [];
      }

      onSubmit(data);
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          position={"relative"}
          w={"100%"}
          maxW={"625px"}
        >
          <form onSubmit={handleSubmit(submitHandler)}>
            <Box
              paddingBottom={"80px"}
              h={"86.5vh"}
              w={"100%"}
              overflowY={"scroll"}
              sx={{
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
                "&::-moz-scrollbar": {
                  width: "4px",
                },
                "&::-moz-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
              }}
            >
              <Flex
                alignItems={"center"}
                p={"25px 24px 24px 24px"}
                position={"relative"}
                borderBottom={"1px solid var(--border-input-employee)"}
              >
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  {isEdit ? "Chỉnh sửa đăng ký làm bù" : "Tạo đăng ký làm bù"}
                </Text>
                <Box
                  position={"absolute"}
                  top={"24px"}
                  right={"24px"}
                  cursor={"pointer"}
                  onClick={onClose}
                >
                  <Image src={IconX} />
                </Box>
              </Flex>
              <Box
                paddingTop={"24px"}
                paddingBottom={"41px"}
                maxW={"545px"}
                margin={"0 auto"}
              >
                <Box>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"16px"}
                  >
                    <SelectControl
                      label={"Nhân viên tạo"}
                      dataOption={employees}
                      placeholder="Chọn nhân viên"
                      selectedMain={watch("employeeId")}
                      onChange={onchangeEmpoyeeList}
                      onFocus={() => handleFocus("employeeId")}
                      onBlur={() => handleBlur("employeeId")}
                      state={focusStates["employeeId"]}
                      registerProps={register("employeeId")}
                      errorMessage={errors.employeeId}
                      mwidth="100%"
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </Flex>
                  <Box mt={"16px"} borderRadius={"8px"}>
                    <Flex mt={"16px"}>
                      <FormControl
                        flex={1}
                        zIndex={zIndex === "dayLeave" ? 3 : 1}
                      >
                        <FormLabel
                          mb={"6px"}
                          fontSize={{ base: "12px" }}
                          fontWeight={400}
                          color={
                            focusStates["startTime"]
                              ? "var(--color-option-employee-hover)"
                              : "var(--color-label-employee)"
                          }
                        >
                          <Flex alignItems="center" gap="4px">
                            Ngày nghỉ
                            {/* <Text
                              fontSize={{ base: "12px" }}
                              color={"red"}
                              lineHeight={"15px"}
                            >
                              *
                            </Text> */}
                          </Flex>
                        </FormLabel>
                        <InputGroup>
                          <DatePicker
                            width="100%"
                            selected={watch("dayLeave")}
                            onChange={(date) =>
                              handleDatePickerChange(date, "dayLeave")
                            }
                            dateFormat="dd/MM/yyyy"
                            locale="vi"
                            placeholderText="dd/mm/yy"
                            className="custom-datepicker datePickerStyle"
                            onFocus={() => {
                              setZIndex("dayLeave");
                              handleFocus("dayLeave", "dayLeave");
                            }}
                            onBlur={() => handleBlur("dayLeave")}
                          />
                          <InputRightElement pointerEvents="none" h={"44px"}>
                            <Image src={calendarIcon} />
                          </InputRightElement>
                        </InputGroup>
                        {errors.dayLeave && (
                          <Text fontSize={{ base: "12px" }} color={"red"}>
                            {errors.dayLeave.message}
                          </Text>
                        )}
                      </FormControl>
                    </Flex>

                    <Flex mt={"16px"}>
                      <TextareaControl
                        label="Ghi chú"
                        placeholder="Nhập ghi chú"
                        errors={errors.note}
                        register={register("note")}
                        onFocus={() => handleFocus("note")}
                        onBlur={() => handleBlur("note")}
                        state={focusStates["note"]}
                        mwidth="100%"
                        height="180px"
                      />
                    </Flex>

                    {defaultValues?.status === "APPROVED" && (
                      <Flex mt={"16px"}>
                        <InputControl
                          type="number"
                          // step="any"
                          label="Số công"
                          placeholder="Nhập số công"
                          errors={errors.workingDayRate}
                          register={register("workingDayRate")}
                          onFocus={() => handleFocus("workingDayRate")}
                          onBlur={() => handleBlur("workingDayRate")}
                          state={focusStates["workingDayRate"]}
                          mwidth={"100%"}
                          onlyPositiveNumbers={true}
                          isRate={true}
                          isRequired={true}
                        />
                      </Flex>
                    )}

                    {/* Ảnh UNC mới */}
                    <Box flex={1} mt={"24px"}>
                      <Box mt={6}>
                        <Flex justify="space-between" align="center" mb={2}>
                          <Flex alignItems="center" gap="4px">
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Ảnh
                            </Text>
                            {/* <Text
                              fontSize={{ base: "12px" }}
                              color={"red"}
                              lineHeight={"15px"}
                            >
                              *
                            </Text> */}
                          </Flex>
                          <Button size="sm" onClick={handleAddImages}>
                            + Thêm ảnh
                          </Button>
                        </Flex>

                        {images.map((img, index) => (
                          <Box
                            key={img.id || index}
                            mb={4}
                            ref={(el) => (imageRefs.current[index] = el)}
                          >
                            <Flex
                              border="1px solid #ccc"
                              borderRadius="8px"
                              p={2}
                              align="center"
                              gap={4}
                              position={"relative"}
                              justifyContent={"center"}
                            >
                              <Box w="100%" h="200px" position="relative">
                                {img.imageUrl || img.path ? (
                                  <Image
                                    src={
                                      img.imageUrl || `${baseURL}/${img.path}`
                                    }
                                    objectFit="contain"
                                    w="100%"
                                    h="100%"
                                    borderRadius="8px"
                                  />
                                ) : (
                                  <Text
                                    fontSize="sm"
                                    color="gray.400"
                                    textAlign="center"
                                    mt="80px"
                                  >
                                    Chưa có ảnh
                                  </Text>
                                )}

                                <Input
                                  type="file"
                                  accept="image/*"
                                  opacity={0}
                                  position="absolute"
                                  top={0}
                                  left={0}
                                  w="100%"
                                  h="100%"
                                  cursor="pointer"
                                  onChange={(e) => handleChangeImages(e, index)}
                                />
                              </Box>

                              <Box
                                position="absolute"
                                top="8px"
                                right="8px"
                                zIndex={2}
                              >
                                <Button
                                  size="sm"
                                  colorScheme="red"
                                  onClick={() => handleRemoveImages(index)}
                                >
                                  Xóa
                                </Button>
                              </Box>
                            </Flex>
                            {!img.imageUrl && !img?.status && (
                              <Text
                                fontSize="12px"
                                color="red"
                                lineHeight={"15px"}
                                mt={"8px"}
                                textAlign={"right"}
                              >
                                Vui lòng chọn ảnh
                              </Text>
                            )}
                            {img.imageUrl && !img.status && (
                              <Text
                                fontSize="12px"
                                color="red"
                                lineHeight={"15px"}
                                mt={"8px"}
                                textAlign={"right"}
                              >
                                {img.uploading
                                  ? "Đang tải ảnh lên..."
                                  : "Tải ảnh lên thất bại, vui lòng bấm Tải lại"}
                              </Text>
                            )}
                            <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                              {!img.status && img.file && (
                                <Button
                                  bg={"var(--linear-gradient-employee)"}
                                  color={"var(--color-main)"}
                                  fontSize={"12px"}
                                  lineHeight={"17px"}
                                  // p={"6px 27px 5px 28px"}
                                  fontWeight={"600"}
                                  _hover={{
                                    filter: "brightness(90%)",
                                  }}
                                  onClick={() => handleUploadImages(index)}
                                  isDisabled={!img.file}
                                  h={"28px"}
                                  minH={"28px"}
                                  w={"90px"}
                                  isLoading={isLoadingUpload || img.uploading}
                                >
                                  Tải lại
                                </Button>
                              )}
                            </Flex>
                          </Box>
                        ))}

                        {errors?.images?.message && !imagesError && (
                          <Text fontSize="12px" color="red" lineHeight={"15px"}>
                            {errors?.images?.message}
                          </Text>
                        )}
                      </Box>
                    </Box>
                    {/* Kết thúc ảnh */}
                  </Box>
                </Box>
              </Box>
              <Box
                position={"absolute"}
                w={"100%"}
                bottom={"0"}
                bg={"var(--color-main)"}
                borderTop={"0.5px solid var(--bg-line-employee)"}
                borderRadius={"0px 0px 16px 16px"}
                zIndex={3}
              >
                <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                  <Button
                    w={"112px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-option-employee-hover)"}
                    borderRadius={"8px"}
                    border={"1px solid var(--color-option-employee-hover)"}
                    bg={"var(--color-main)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                    onClick={onClose}
                  >
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    w={"112px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-main)"}
                    borderRadius={"8px"}
                    bg={"var(--color-option-employee-hover)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Lưu
                  </Button>
                </Flex>
              </Box>
            </Box>
          </form>
        </ModalContent>
      </Modal>
    );
  }
);

export default FormDetail;
